export default {
  assemblePage: {
    QuickJoin: 'Quick Join, Instant Group Formation',
    PeopleGroup: 'People',
    InProgress: 'In Progress, Only Need',
    PeopletoComplete: 'People to Complete',
    JoinDirectly: 'Join',
    MustJoin: 'Must Join This Week',
    line: 'I have a bottom line',
    JoinNow: 'Join Now',
    Oops: 'Oops, there are no relevant group buys available.',
    Why: 'Why are the group buys here so cost-effective?',
    Groupbuying: 'Group buying is fun in the moment and even more enjoyable when you keep doing it!'
  }
}
